import { FC, SVGProps } from 'react';

export const CheckListIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.3335 13.5H14.0002" stroke="#141414" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.3335 8.83301H14.0002" stroke="#141414" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.3335 4.16699H14.0002" stroke="#141414" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 4.16634L2.66667 4.83301L4.66667 2.83301" stroke="#141414" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 8.83333L2.66667 9.5L4.66667 7.5" stroke="#141414" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 13.5003L2.66667 14.167L4.66667 12.167" stroke="#141414" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
